import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="404 - Siden blev ikke fundet"
        description="Siden du leder efter findes desværre ikke på Insightly Care."
      />

      <section className="min-h-[60vh] flex items-center justify-center py-20 bg-slate-50">
        <div className="max-w-md w-full px-4 text-center space-y-6">
          <div className="w-20 h-20 bg-slate-200 text-black flex items-center justify-center text-4xl mx-auto">
            <i className="fa-solid fa-compass-slash text-black" aria-hidden="true" />
          </div>

          <div className="space-y-2">
            <span className="text-xs font-black uppercase tracking-widest text-black">
              Fejl 404
            </span>
            <h1 className="text-3xl font-extrabold text-black tracking-tight">
              Siden blev ikke fundet
            </h1>
            <p className="text-black text-sm leading-relaxed">
              Den side du forsøger at tilgå, er enten flyttet, slettet eller findes ikke.
            </p>
          </div>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto px-6 py-3 bg-slate-900 hover:bg-black text-white font-bold transition-colors"
            >
              Gå til Forsiden
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto px-6 py-3 bg-white hover:bg-slate-100 text-black font-bold border border-slate-300 transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
